export class ControlSlider {
    title: string;
    inputName: string;
    min: number;
    max: number;
    _value: number;
    drawFunction: Function | undefined;
    callback: Function | undefined;

    set value(value: number){
        this._value = value;
        this.draw();
        this.checkCallback();
    }

    get value(){
        return this._value;
    }

    constructor(title: string, inputName: string, min: number, max: number, value: number, drawFunction?: Function | undefined, callback?: Function | undefined){
        this.title = title;
        this.inputName = inputName;
        this.min = min;
        this.max = max;
        this._value = value;
        this.drawFunction = drawFunction;
        this.callback = callback;
    }

    draw(){
        if(this.drawFunction) this.drawFunction();
    }

    checkCallback(){
        if(this.callback) this.callback();
    }
}